import type { WorkingTreeChangeKind } from '../../types.js';
import { MAX_HYDRATE_LINES_PER_FILE, MAX_HYDRATE_LINES_PER_GAP } from './constants.js';

export async function collectGapInjectLines(options: {
  change: WorkingTreeChangeKind;
  gapOldStart: number;
  gapOldEnd: number;
  gapNewStart: number;
  gapNewEnd: number;
  injectedTotal: number;
  blobLines: () => Promise<string[] | null>;
  diskLines: () => Promise<string[] | null>;
}): Promise<string[] | null> {
  if (options.injectedTotal >= MAX_HYDRATE_LINES_PER_FILE) return null;

  const remaining = MAX_HYDRATE_LINES_PER_FILE - options.injectedTotal;

  if (options.gapNewEnd >= options.gapNewStart && options.change !== 'removed') {
    const nNew = options.gapNewEnd - options.gapNewStart + 1;
    if (
      options.gapOldEnd < options.gapOldStart ||
      options.gapOldEnd - options.gapOldStart + 1 === nNew
    ) {
      const cap = Math.min(nNew, MAX_HYDRATE_LINES_PER_GAP, remaining);
      const dl = await options.diskLines();
      if (dl && cap > 0) {
        return dl.slice(options.gapNewStart - 1, options.gapNewStart - 1 + cap);
      }
    }
    return null;
  }

  if (options.gapOldEnd >= options.gapOldStart && options.change === 'removed') {
    const nOld = options.gapOldEnd - options.gapOldStart + 1;
    const cap = Math.min(nOld, MAX_HYDRATE_LINES_PER_GAP, remaining);
    const bl = await options.blobLines();
    if (bl && cap > 0) {
      return bl.slice(options.gapOldStart - 1, options.gapOldStart - 1 + cap);
    }
  }

  return null;
}
